import http from "infra/http";
import { useQuery } from "react-query";
import { FracaoItem } from "../typings";

function useGetFracoes() {
  return useQuery([`/v1/fracao`], async () => {
    const { data } = await http.get(`/v1/fracao`);
    return data as FracaoItem[];
  });
}

export default useGetFracoes;
